window.localizedStrings = {
  frame: {
    backnaverror:
      "Use the navigation features in this application instead of the browser navigation",
    communicationerror:
      "There was a fatal communication error.\nContact your system administrator.",
    emerror: "Could not find an EM node containing ",
    multiplenodewarning: 'Warning: Found more than one node with id="',
    controlerror: "ERROR: Could not find control",
    controliderror: "ERROR: Could not find control id ",
    headererror:
      "Header could not be loaded due to lost connection.  Retry or contact administrator.",
    loading: "Loading...",
    cancel: "Cancel",
    more: "More...",
    embeddedpopup: "Infor Embedded Popup",
    exception: "JavaScript Error",
    finishedloading: "Finished Loading",
    opening: "Opening ",
    closing: "Closing ",
    selecting: "Selecting ",
    safemode: "<span class='safemodeMessage'>SafeMode</span>"
  },
  tabpane: {
    taberrortitle: "Tab Error",
    undefinedcontrolerror: "Control is undefined",
    tabiderror: "Could not find tab id {0}",
    controlinitializederror: "Control {0} has not been initialized",
    tabnotfounderror: "Could not find tab or control",
    fillmethoderror: "Tab has no fill method",
    notloadedmessage: "Not Loaded"
  },
  device: {
    devicecontrolerror:
      "Error encountered in device control. Contact your system administrator for support."
  },
  webservice: {
    inprogresstext: "In Progress",
    invalargtext: "Invalid argument",
    notreadytext: "Service unavailable",
    invalrestext: "Invalid response",
    unsupfuntext: "Function not found",
    unknownstext: "Unknown server error",
    acdeniedtext: "Access denied",
    soapunavtext: "Soap not available",
    htcintertext: "HTC internal error",
    invalporttext: "Invalid active port",
    invalheadtext: "Invalid headers",
    clienterror: "Client",
    servererror: "Server"
  },
  attachments: {
    atclabelwithtotal: " Attachments({0})",
    atclabel: " Attachments"
  },
  calendar: {
    timeboxlabel: "Time:",
    todaylabel: "Today",
    oneweekagolabel: "One Week Ago",
    onemonthagolabel: "One Month Ago",
    sixmonthsagolabel: "Six Months Ago",
    lastyearlabel: "Last Year",
    nextweeklabel: "Next Week",
    nextmonthlabel: "Next Month",
    nextyearlabel: "Next Year"
  },
  ipsaddress: {
    propertyeditortitle: "Address Information",
    checkboxcontroltext: "Address Control",
    controldisplayname: "Address"
  },
  ipsasset: {
    controldisplayname: "Asset"
  },
  ipsbuttonproxy: {
    controldisplayname: "Button"
  },
  ipscheckboxproxymanager: {
    checkboxtext: "New Check Box"
  },
  ipscheckboxproxy: {
    controldisplayname: "CheckBox"
  },
  ipscontextmenuitem: {
    gridcolumntext: "New Item",
    controldisplayname: "Context Menu Item"
  },
  ipsdropdownbox: {
    dropdownboxtext: "New Drop-Down Box",
    controldisplayname: "DropDownBox"
  },
  ipsdropdownitemproxymanager: {
    controldisplayname: "DropDownBox Item"
  },
  button: {
    updateprocess: "Update - Shortcut( 'Ctrl+E' )"
  },
  ipstextbox: {
    editboxtext: "New Edit Box",
    controldisplayname: "EditBox",
    validtypeserror: "Expecting valid types for this editbox"
  },
  ipstextboxproxy: {
    editboxtext: "New Edit Box",
    controldisplayname: "EditBox",
    validtypeserror: "Expecting valid types for this editbox"
  },
  ipstexttemplate: {
    controldisplayname: "Text Template"
  },
  gridcolumnproxymanager: {
    validtypeserror: "Expecting valid types for this Grid Column",
    controldisplayname: "Grid Column"
  },
  gridmapcoordinatorcontrolproxymanager: {
    controldisplayname: "Grid Map Coordinator"
  },
  ipsdatagrid: {
    controldisplayname: "Grid"
  },
  ipsgrouparea: {
    groupareatitle: "Group Area",
    controldisplayname: "GroupArea"
  },
  ipsfieldset: {
    groupboxtitle: "Group Box",
    controldisplayname: "GroupBox"
  },
  ipshtmlareaproxymanager: {
    htmlareatext: "HTML Area",
    controldisplayname: "HtmlArea"
  },
  ipslabel: {
    validtypeserror: "Expecting valid types for this editbox",
    controldisplayname: "Label",
    labeltext: "New Label"
  },
  ipslabelproxy: {
    validtypeserror: "Expecting valid types for this editbox",
    controldisplayname: "Label",
    labeltext: "New Label"
  },
  mapdrawerproxymanager: {
    mapdrawertooltip: "Infor GIS",
    controldisplayname: "Infor GIS"
  },
  scriptareaproxymanager: {
    controldisplayname: "Script"
  },
  ipssearchrangeproxy: {
    validtypeserror: "Expecting valid types for this editbox",
    controldisplayname: "Search Range"
  },
  splitterproxymanager: {
    diverror: "splitter div is missing",
    leftbodyerror: "Left side body for splitter {0} is null",
    rightbodyerror: "Right side body for splitter {0} is null",
    outertagerror: "outer splitter tag is missing",
    leftgroupboxerror: "left splitter groupbox is missing",
    rightgroupboxerror: "right splitter groupbox is missing",
    controldisplayname: "Splitter"
  },
  ipsgridcolumnproxymanager: {
    validtypeserror: "Expecting valid types for this Grid Column"
  },
  ipstabpageitemproxymanager: {
    controldisplayname: "Tab Page"
  },
  ipstabset: {
    controldisplayname: "Tab Pane"
  },
  ipsplaceholder: {
    ucctext: "User Control Container",
    controldisplayname: "UserControlContainer"
  },
  dashboard: {
    loadingtext: "Loading...",
    imageservererror: "Could not contact dashboard image server:"
  },
  decisionmodel: {
    ancestrytext: "Node Path",
    searchtext: "Search Results",
    duplicatenodeerror: "Duplicate Node Id: {0}",
    childnodeerror: 'Can\'t add a node "{0}" as a child of a Result Type',
    siblingnodeerror: 'Can\'t add a node "{0}" as a sibling of a Result Type',
    siblingresultnodeerror:
      'Can\'t add a result node "{0}" as a sibling of another node',
    secondrooterror: "Attempt to add second root",
    parentnodeerror: 'Parent node "{0}" not found.',
    moveerror: "Move would create a cycle in the tree.",
    canceltext: "Cancel",
    addbeforetext: "Add Decision Before",
    addaftertext: "Add Decision After",
    addfirstchildtext: "Add Decision As First Child",
    addresulttext: "Add Result",
    deletenodetext: "Delete This Node",
    editnodetext: "Edit This Node",
    copytext: "Copy here",
    copystructuretext: "Copy structure here",
    copynodetext: "Copy node here",
    copysubtreetext: "Copy subtree here",
    movetext: "Move subtree here",
    nodepresentlog: 'Node "{0}": present on server, not found on client.\n',
    nodeparentlog:
      'Node "{0}": parent is "{1}" on server, parent is "{2}" on client.\n',
    nodepositionlog:
      'Node "{0}": at position "{1}" on server, at position "{2}" on client.\n',
    nodetextlog:
      'Node "{0}": text is "{1}" on server, text is "{2}" on client.\n',
    nodechildrenlog:
      'Node "{0}": has {1} children on server, has {2} children on client.\n'
  },
  dropdownbox: {
    listitem: "{0} value must be an item in the list",
    placeholder: "Select a Value"
  },
  validation: {
    text: "This field",
    requiredfield: "{0} is required",
    minfieldlength:
      "Field length ({0}) does not meet minimum length requirement ({1})",
    maxfieldlength:
      "Field length ({0}) exceeds maximum length requirement ({1})",
    invalidphonenumber: "Entry is not a valid phone number.",
    invaliddigits: "Not enough digits entered for element phone field.",
    invalidnumber: "Entry is not a valid number.",
    invalidfieldrange: "Field value out of range.",
    invalidmindate: "Entered date is below minimum allowed date.",
    invalidmaxdate: "Entered date is above maximum allowed date.",
    invalidtime: "Entry is not a valid time."
  },
  groupbox: {
    multipleelements: 'There is more than one element "{0}_main" on the page',
    nullheader: "Header for groupbox {0} is null",
    nulltable: "Table for groupbox {0} is null ",
    nullbody: "Body for groupbox {0} is null"
  },
  htmlarea: {
    fieldrequired: "This field is required.",
    textcolortitle: "Text Color",
    highlightcolortitle: "Highlight Text",
    fontdropdowntitle: "Change&nbsp;Font",
    fontdropdownopt0: "Courier&nbsp;New",
    fontdropdownopt1: "Arial",
    fontdropdownopt2: "Comic&nbsp;Sans&nbsp;MS",
    fontdropdownopt3: "Lucida&nbsp;Console",
    fontdropdownopt4: "Tahoma",
    fontdropdownopt5: "Times&nbsp;New&nbsp;Roman",
    fontdropdownopt6: "Trebuchet&nbsp;MS",
    fontdropdownopt7: "Verdana",
    fontsizedropdowntitle: "Change&nbsp;Font&nbsp;Size",
    fontsizedropdownopt0: "Smallest",
    fontsizedropdownopt1: "Smaller",
    fontsizedropdownopt2: "Medium",
    fontsizedropdownopt3: "Large",
    fontsizedropdownopt4: "Larger",
    fontsizedropdownopt5: "Largest"
  },
  linearassetviewer: {
    screenrange: "Fit this Range to Screen",
    screenlength: "Fit Entire Length to Screen",
    maxzoom: "Zoom to Maximum"
  },
  monthlycalendar: {
    loadingtext: "Loading...",
    moretext: "more...",
    gotodaylabel: "Go to Today"
  },
  networkbrowser: {
    nodenotfound: 'Existing node "{0}" not found.'
  },
  popupcalculator: {
    unrecoperator: "Unrecognized operator: {0}"
  },
  proxypropertyeditor: {
    numitems: "{0} Item(s)...",
    nobind: "No Bind",
    edittext: "Edit",
    controlpropertiestitle: "{0} Control Properties",
    propertytypeerror: "Could not determine property type of {0}: {1}",
    confirmdelete: 'Are you sure you want to permanently delete: {0} ?',
    invalidcharacters: "Invalid characters - Double quotes are not allowed",
    invalidvalue: "Invalid value: {0}",
    noformula: "No Formula",
    bindalreadyexists: "An existing control is bound to this property",
    cannotdeletecontrols: '<br><br>Out-of-the-box controls cannot be deleted: {0}'
  },
  splitter: {
    headernull: "Header for splitter {0} is null",
    splitternull: "Splitter bar for splitter {0} is null",
    leftbodynull: "Left side body for splitter {0} is null",
    rightbodynull: "Right side body for splitter {0} is null"
  },
  tree: {
    treeerror: "Tree Error",
    graftnodeerror: "Attempt to graft a node to its own descendant",
    detailgraftnodeerror:
      'Attempt to graft node "{0}" to its own descendant "{1}".',
    deletenodeerror: "Cannot delete the root node in a tree.",
    detaildeletenodeerror: 'Attempting to delete node "{0}".',
    nodeparenterror: "Could not find node parent.",
    detailnodeparenterror: 'Attempting to reload parent of node "{0}".',
    replaceparenterror: "Could not find replace parent.",
    detailreplaceparenterror: 'Attempting to replace node "{0}".',
    loadingtext: "Loading...",
    graftusernode: 'Graft "{0}" here',
    cancelgraft: "Cancel Graft",
    graftnode: "Graft this Node",
    duplicatenodeiderror: "Duplicate Node Id.",
    detailduplicatenodeiderror:
      'The node id "{0}" is already used in the tree.',
    treenodeerror: 'Could not find tree node "{0}".'
  },
  autocomplete: {
    error: "Auto complete is unavailable",
    numofmatches: "<i>Showing top {0} out of {1} matches.</i>",
    searching: "Searching using auto complete",
    nomatches: "No matches",
    fuzzysearch: "Results similar to {0}"
  }
};
